
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ChangePasswordModal from "./ChangePasswordModal";

export default function Navbar() {
  const navigate = useNavigate();
  const { logout, user, isAdmin } = useAuth();

  const [showProfile, setShowProfile] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);

  const profileRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  // Close profile dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfile(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

const initial = user?.full_name?.trim()?.charAt(0)?.toUpperCase() || "U";
  return (
    <header className="navbar">
      <div className="navbar-brand">
        <img
          src="/myglogotrnsparent.png"
          alt="myG Logo"
          className="navbar-logo"
        />

        <span className="navbar-divider" />

        <span className="navbar-title">
          <span>QR Studio</span>
        </span>
         {/* <img
          src="/QR-BLACK2.png"
          alt="myG Logo"
          className="navbar-logo"
        /> */}


      </div>

      {/* Profile */}
      <div className="navbar-profile" ref={profileRef}>
        <button
          className="profile-button"
          onClick={() => setShowProfile(!showProfile)}
          aria-label="Profile"
        >
          <span className="profile-icon">
            {initial}
          </span>
        </button>

        {showProfile && (
          <div className="profile-dropdown">
            <div className="profile-info">
              <div className="profile-avatar-large">
                {initial}
              </div>

              <div className="profile-details">
                <div className="profile-fullname">
                  {user?.full_name || "User"}
                </div>

                <div className="profile-username">
                  {user?.username}
                </div>
              </div>
            </div>

            <div className="profile-divider" />

            {!isAdmin && (
              <button
                className="profile-menu-item"
                onClick={() => {
                  setShowProfile(false);
                  setShowChangePassword(true);
                }}
              >
                <span>🔒</span>
                Change Password
              </button>
            )}

            <button
              className="profile-menu-item logout-item"
              onClick={handleLogout}
            >
              <span>↪</span>
              Logout
            </button>
          </div>
        )}
      </div>

      {showChangePassword && (
        <ChangePasswordModal
          onClose={() => setShowChangePassword(false)}
        />
      )}
    </header>
  );
}

